module.exports = __webpack_public_path__ + "static/media/Q6-1.89a8f197.jpg";